<template>
  <div id="CdssSearch">
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas  fa-file-code"></i><b>Manage CDSS:</b>
        
      </template>
    </Subtitle>
    <Card>
    <CardBody>
      <p>Manage CDSS is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
      </p>
    </CardBody>
  </Card> 
 
    <form class="card p-0 mb-1" id="SearchForm">
      <div class="card-header d-flex align-items-center pl-1" style="height: 1rem; text-align: left">
        <h5>
          <small class="text-muted"
            ><b
              ><i class="fas fa-search-plus"></i>Search: Fee Type, Service Code and Effective Date all required</b
            ></small
          >
        </h5>
      </div>

      <div class="form-row p-1">
        <div class="form-group col-sm-3">
          <!-- <option value=" ">GP</option> -->
            <label for="inputEmail4" class="label-small">Fee Type</label>
          <select
                  class="form-control form-control-xs my-0"
                  :disabled="!AllowEdit"
                  v-model="feetype"                  
                  @change="handlefeetypeChange"                
                 >                
                  <option value="GP">GP</option>                  
          </select>      
        </div>

        <div class="form-group col-sm-3">
          <label for="inputEmail4" class="label-small">ServiceCode</label>
          <input 
            id="servicecode"
            v-model="servicecode"
            maxlength="5"
            class="form-control form-control-xs" 
            typeable
          />          
          <div class="row" v-show="$v.servicecode.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.servicecode.required">Service Code is required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.servicecode.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.servicecode.numeric">Service Code must be a number.</small>
            </div>
          </div>
          <!-- <div class="row" v-show="$v.servicecode.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.servicecode.minLength">Service Code must be valid.</small>
            </div>
          </div> -->
        </div>

        <!-- typeable   -->
        <div class="form-group col-sm-3">
          <label for="inputEmail4" class="label-small">Effective Date</label>               
                 <!-- :open-date="new Date()"               -->
          <div>   
            <datepicker class="servdatapick"  
              
      
              v-model="effectivedate" 
              :open-date="new Date()"
              :format="DateFormat" 
              id="effectivedate" 
              :bootstrap-styling="true" 
              :input-class="datapickClass" 
              name="effectivedate">
            </datepicker>                        
          </div>
          <div class="row" v-show="$v.effectivedate.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.effectivedate.required">Effective date is required.</small
              >
            </div>
          </div>
        </div>
    


        <div class="form-group col-sm-3">
          <label for="inputPassword4" class="label-small"> </label>
          <div class="">
            <button
              v-on:click="GetCDSSInfo"
              type="button"
              class="btn btn-primary btn-sml mt-1"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </form>  
    <div id="SearchResult" v-if="searched" class="p0">
      <div class="mt-2">
        <v-client-table
          :columns="columns"
          :data="tableData"          
          :options="options"
        >             
        </v-client-table>
      </div>
      <div class="card-header d-flex align-items-center pl-1" style="height: 1rem; text-align: left">
        <h5>
          <small class="text-muted"
            ><b
              >Note, if the Maximum Fee is $0.00, then the CDSS Guide has marked the cost as “I.C.”</b
            ></small
          >
        </h5>
      </div>
    </div>    
  </div>    <!-- CdssSearch end --> 
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import Subtitle from "@/Common/Default/SubTitle.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import Vuelidate from "vuelidate";
import {
  helpers,
  required,
  minLength,
  sameAs,
  not,
  maxLength,
  numeric,
  integer,
  between,
} from "vuelidate/lib/validators";
// import BModal from "bootstrap-vue/es/components/modal/modal";
// import BModalDirective from 'bootstrap-vue/es/directives/modal/modal';

// Vue.use(BModalDirective);

Vue.use(Vuelidate);

export default {
  props: {
    AllowEdit:'',
    Type: "",
  },
  name: "CdssSearch",
  data: function () {
    return {
      MsgPopup: "",
      showError: false,
      showEdit:true,
      showInfoModal:false,
      showEditModal:false,
      UserData: '',
      TypeHeadinptClass: "form-control form-control-xs",
      boxTwo: "",
      BtnSubmitdisabled: 0,
      AppServiceID: 6,
      MaxMatch: 20,
      title: "",
      //Subtitle: "",  
      servicecode: "",
      feetype: "GP",
      effectivedate: "",
      //effectivedate: "2023/01/01",
      tableData: [],
      // tableData: null,
      serviceDate: "",
      DateFormat: '',
      datapickClass: 'form-control form-control-xs my-0',
      showInfo: false,
      servicetype:'', 
      service:'SUP',
      patient: null,
      PopUpVar: PopUpVariant,
      showDetailModal: false,
      showMessageModal: false,
      searched: false,
      phListingParams: [],
      cdssListingParams: [],
      phDetailParams: [],
      phDetails: [],      
      Msg: "",
      Services: "",
      isAssessor: false,
      interchggrp: "",
      columns: ["feetype", "servicecode", "desc", "effectivedate", "expirydate", "category", "subcategory", "qty", "maxcharge", "silvercharge", "codetypeinfo" ],
      options: {
        texts: {
          count:
            "Showing {from} to {to} of {count} records|{count} records|One record",
          first: "First",
          last: "Last",
          limit: "Records:",
          page: "Page:",
          noResults: "No CDSS Found",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },

        perPage: 5,
        perPageValues: [5],

        dateColumns: ["effectivedate"],

        filterable: true,

        templates: {
          effectivedate(h, row) {
            return moment(row.effectivedate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          expirydate(h, row) {
            return moment(row.expirydate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          // desc(h, row) { 
          //   return <div style="font-size: 70%">{row.desc}</div>;
          // }, 
          maxcharge(h, row) {   
            return <div>${Number.parseFloat(row.maxcharge).toFixed(2)}</div>; 
          },
          silvercharge(h, row) {   
            return <div>${Number.parseFloat(row.silvercharge).toFixed(2)}</div>; 
          },           
          codetypeinfo(h, row) {
            switch(row.codetypeinfo.toUpperCase())
            {
              case 'E':
                  return 'EXPENSES EXTRA'
              case 'L':
                  return 'LABORATORY PROCEDURES EXTRA'                  
              case 'EL':
                  return <div style="padding-right:0px !important"> <span> EXPENSES EXTRA </span><span><br/> LABORATORY PROCEDURES EXTRA </span></div>;
              case 'LE':
                  return <div style="padding-right:0px !important"> <span> EXPENSES EXTRA </span><span><br/> LABORATORY PROCEDURES EXTRA </span></div>;
              default:
                  return '';                          
            }             
          },
        },

        headings: {
          // status: "Status",
          // info:'View',
          // edit: 'Edit',
          feetype: "Fee Type",
          servicecode: "Service Code",
          desc: "Category & Classification",                
          effectivedate: "Effective Date",
          expirydate: "Expiry Date",
          category: "Service Title",
          subcategory: "Specific Service",
          qty: "Number of Films",
          maxcharge: "Max Fee",    
          silvercharge: "Max Fee - Amalgam", 
          codetypeinfo: "Extra Information",
        },

        pagination: {
          edge: true,
          nav: "scroll",
          chunk: 5,
        },

        sortable: [
          "feetype",
          "servicecode",
          "effectivedate",
          "expirydate",
          "category",
          "qty",
          
        ],

        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },

  components: {
    Card,
    CardBody,
    TileNote,
    Modal:Modal,
    Datepicker,
    //CDSSDetail,
    //QDSEAddEdit,
    Subtitle,
  },

  validations() {
    return {      
      servicecode: {
        required,
        numeric
        //minLength:5
      }, 
      effectivedate: {  
        required,      
        //ValidValue : value => this.ValEffDate(),
      }, 
    };
  },

  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },

  methods: {
    Show() {
      this.showInfo = true;
    },
    closeModal() { 
        this.showEditModal = false;
        //this.loadTable();
      },

    GetCDSSInfo() {
      var vm = this;
      this.$v.$touch();
        if (!this.$v.$invalid) {        
          vm.loadTable();
      }
    },

    handlefeetypeChange(e) {

    },

    ValEffDate(){
        console.log('at ValEffDate check: ',this.effectivedate)
        //if((this.effectivedate !== ''  || this.effectivedate !== null || this.effectivedate !== undefined))      
        if((this.effectivedate.length == 0 || this.effectivedate !== null || this.effectivedate !== undefined))         
        {
            return true;           
        }
        else
        {
           return false;
        }        
      },  
    GetServiceType(){
          
           var vm = this;
           var params = new URLSearchParams();            
           params.append('ServiceID', this.AppServiceID);
            axios.get('SaskHealthApi/Codes/GetServiceType?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }, params})
            .then(function (response) {
                //console.log(response.data);
                vm.Services=response.data;
                })
            .catch(function (er) {

                console.log(er)
                
                })
      },    
      showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          console.log("at value " + value);
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    loadTable(){     
      var vm = this; 
      // vm.searched = false;
      vm.searched = true;
      this.SetCDSSSearchParms(vm);
      var params = new URLSearchParams();
      console.log("Search param = " + vm.cdssListingParams);
      params = vm.cdssListingParams;      
      axios
        .get("SaskHealthApi/Host/GetCdssInq", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.tableData = response.data;
        })
        .catch(function (er) {
          console.log(er);
          vm.tableData = [];
          if (er.response) {
              if(er.response.status == 400)
                {
                        if( er.response.data.message.length)
                        {
                        vm.showMsg(er.response.data.message,"","CDSS Service Code Error");

                        }
                }
                else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","CDSS Service Code Error");
                     
              }
              else 
              vm.showMsg("Network Related Error ! Please contact system administrator.","","HSN Search Error");

        });
    },

    ClosePopup() {
      this.showError = false;
    },
    
    SetCDSSSearchParms(vm) {
       
      console.log('effective date 1' + vm.effectivedate)        
      var frm =   moment(vm.effectivedate).format("YYYYMMDD").toString();  
      console.log('effective date' + frm) 
      vm.cdssListingParams = new URLSearchParams();      
      vm.cdssListingParams.append("feetype", this.feetype);
      vm.cdssListingParams.append("servicecode", this.servicecode);
      vm.cdssListingParams.append("effectivedate", frm);
    },
 
    CloseDetailModal() {
      this.showDetailModal = false;
    },

    PopMsgClose() {},   
  },
  computed: {
  },

  created: function () {   
    var vm = this; 
    this.DateFormat = this.$store.getters.GetDateFormat; 
    //moment(this.UserData.effectivedate==undefined?new Date()
    this.effectivedate = moment(new Date()).toString(); 
    this.showError = false;
    //console.log('created eff date: ', this.effectivedate); 
  },

  beforeCreate: function () {},

  mounted: function () {
    
    var params = new URLSearchParams();    
    //this.servicetype='SUP'
    this.GetServiceType()
    var vm = this; 
    axios
      .get("SaskHealthApi/Codes/IsAssessorOrSuper?_=" + Date.now(), {
        headers: { Authorization: "Bearer " + localStorage.access_token },
        params,
      })
      .then(function (response) {
        vm.isAssessor = response.data;
      })
      .catch(function (er) {
        console.log(er);
      });      
  },
  //},
};
</script>

<style scopped>
.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
}

.test-modal .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#phModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>